import PersonModel from './person';

// Keeps person's [Type] brand: a subclass can't narrow it to another literal.
export default class AssigneeModel extends PersonModel {}
